import { Store } from "lucide-react";
import { fmtDate, fmtDateTime, money, validityLabel } from "@/lib/api";
import { Empty, ErrorBox, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";

function PackageItem({ cp }) {
  return (
    <div className="surface space-y-3 p-5" data-testid={`my-package-${cp.card_serial}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-bold">{cp.package_name}</p>
          <p className="font-mono text-xs text-slate-500">{cp.card_serial}</p>
        </div>
        <StatusBadge status={cp.status} testId="my-package-status" />
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-slate-400">Price</p><p className="font-semibold">{money(cp.price, cp.currency)}</p></div>
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-slate-400">Validity</p><p className="font-semibold">{validityLabel(cp.validity_value, cp.validity_unit)}</p></div>
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-slate-400">Activated</p><p className="font-semibold">{fmtDate(cp.activated_at)}</p></div>
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-slate-400">Expires</p><p className="font-semibold" data-testid="my-package-expires">{fmtDate(cp.expires_at)}</p></div>
      </div>
      {cp.status === "PENDING_PAYMENT" && (
        <div className="flex gap-2 rounded-xl bg-blue-50 p-3 text-xs text-blue-900"><Store size={15} className="shrink-0" /> Awaiting cashier activation.</div>
      )}
    </div>
  );
}

export default function MyPackages() {
  const { data, error, loading } = useFetch("/customer/packages");
  const pays = useFetch("/customer/payments");
  return (
    <div className="space-y-6">
      <PageHead eyebrow="My Packages" title="Packages & payments" />
      {loading && <Spinner />}
      <ErrorBox error={error} />
      {data?.length === 0 && <Empty title="No packages yet" hint="Your packages appear here once GIA issues your account." />}
      <div className="space-y-4">{data?.map((cp) => <PackageItem key={cp.id} cp={cp} />)}</div>
      <section>
        <h2 className="mb-3 text-base font-bold">Payment history</h2>
        {pays.data?.length === 0 && <Empty title="No payments yet" />}
        <div className="space-y-2" data-testid="payment-history">
          {pays.data?.map((p) => (
            <div key={p.id} className="surface flex items-center justify-between p-3.5" data-testid={`payment-${p.reference}`}>
              <div>
                <p className="flex items-center gap-2 text-sm font-semibold">{p.method === "CASH" ? "Cash (cashier)" : "QR Ph"}</p>
                <p className="font-mono text-[11px] text-slate-500">{p.receipt?.number || p.reference} · {fmtDateTime(p.paid_at || p.created_at)}</p>
              </div>
              <div className="text-right"><p className="text-sm font-bold">{money(p.amount, p.currency)}</p><StatusBadge status={p.status} /></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
